export interface A {}

export enum EmployeeStateType {
  Default = 0,
  Active = 1,
  Deactivated = 2,
}

export const EmployeeStateToBoolean: { [key: number]: boolean } = {
  0: true,
  1: false,
};

export const SearchFieldNames: string[] = [
  'employeeFullName',
  'cnp',
  'employeeEID',
  'email',
];

export const SearchCrtIdToFieldName: { [key: number]: string } = {
  1: SearchFieldNames[0],
  2: SearchFieldNames[1],
  3: SearchFieldNames[2],
  4: SearchFieldNames[3],
};

export const getDeadlineData = () => {
  let deadlines: { id: number; value: string }[] = [];
  for (let index = 1; index < 28; index++) {
    deadlines.push({ id: index, value: index.toString() });
  }
  return deadlines;
};
